import { PortalType } from '@studyportals/domain-client';
import BachelorsPortalDefinition from './bachelors/BachelorsPortalDefinition';
import DistanceLearningPortalDefinition from './distance-learning/DistanceLearningPortalDefinition';
import MastersPortalDefinition from './masters/MastersPortalDefinition';
import PhdPortalDefinition from './phd/PhdPortalDefinition';
import { PortalDefinition } from './PortalDefinition';
import ShortCoursesPortalDefinition from './short-courses/ShortCoursesPortalDefinition';

export class PortalDefinitionHelper {
	public getPortalDefinition(portalType: PortalType): PortalDefinition {
		if (portalType === PortalType.PHD) {
			return PhdPortalDefinition;
		}

		if (portalType === PortalType.MASTER) {
			return MastersPortalDefinition;
		}

		if (portalType === PortalType.BACHELOR) {
			return BachelorsPortalDefinition;
		}

		if (portalType === PortalType.SHORT) {
			return ShortCoursesPortalDefinition;
		}

		if (portalType === PortalType.DISTANCE_LEARNING) {
			return DistanceLearningPortalDefinition;
		}

		throw new Error('Portal type not defined');
	}
}
